module.exports = __webpack_public_path__ + "static/media/vkeyDemo.bc8c760a.gif";